import { STORE } from './i18n';

export const waLink = (text) => {
  const base = `https://wa.me/${STORE.whatsapp}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};

export const buildShippingMessage = ({ model, city, lang }) => {
  const greet = lang === 'es' ? 'Hola Nathanael Appliances Corp' : 'Hi Nathanael Appliances Corp';
  const want  = lang === 'es'
    ? 'Quisiera una cotización para enviar un electrodoméstico a República Dominicana.'
    : "I'd like a shipping quote to the Dominican Republic.";
  const mLbl = lang === 'es' ? 'Electrodoméstico/Modelo' : 'Appliance/Model';
  const cLbl = lang === 'es' ? 'Ciudad de destino' : 'Destination city';
  return [
    greet + ',', '',
    want, '',
    `${mLbl}: ${model || '—'}`,
    `${cLbl}: ${city || '—'}`,
  ].join('\n');
};

export const buildProductMessage = ({ product, lang }) => {
  const greet = lang === 'es' ? 'Hola Nathanael Appliances Corp' : 'Hi Nathanael Appliances Corp';
  const intro = lang === 'es'
    ? 'Estoy interesado/a en este producto:'
    : "I'm interested in this product:";
  const name = lang === 'es' ? product.name_es : product.name_en;
  const lines = [greet + ',', '', intro, '', `• ${name}`, `• ${lang === 'es' ? 'Marca' : 'Brand'}: ${product.brand}`, `• ${lang === 'es' ? 'Modelo' : 'Model'}: ${product.model}`, `• ${lang === 'es' ? 'Precio' : 'Price'}: $${product.price.toFixed(2)}`];
  return lines.join('\n');
};

export const buildCompareMessage = ({ products, lang }) => {
  const greet  = lang === 'es' ? 'Hola Nathanael Appliances Corp' : 'Hi Nathanael Appliances Corp';
  const intro  = lang === 'es'
    ? `Estoy comparando estos ${products.length} modelos. ¿Pueden ayudarme a decidir cuál es mejor para mí?`
    : `I'm comparing these ${products.length} models. Can you help me decide which one is best for me?`;
  const items = products.map((p, i) => {
    const name = lang === 'es' ? p.name_es : p.name_en;
    return [
      `${i + 1}. ${name}`,
      `   ${lang === 'es' ? 'Marca' : 'Brand'}: ${p.brand}`,
      `   ${lang === 'es' ? 'Modelo' : 'Model'}: ${p.model}`,
      `   ${lang === 'es' ? 'Precio' : 'Price'}: $${(p.price || 0).toFixed(2)}`,
    ].join('\n');
  }).join('\n\n');
  return [greet + ',', '', intro, '', items].join('\n');
};
